import { useSuspenseQuery } from "@tanstack/react-query";
import { Ajustes } from "@/components/casca/Ajustes";
import { FormConexao } from "@/components/conexao/FormConexao";
import { FormGoogle } from "@/components/conexao/FormGoogle";
import { conexaoQuery } from "../consultas";

/** O número da clínica, por qual provedor ele fala, e onde vivem agenda e ficha. */
export function Conexao() {
  const {
    data: { estado, slug },
  } = useSuspenseQuery(conexaoQuery());
  return (
    <Ajustes
      titulo="WhatsApp e Google"
      descricao="O número da clínica, por qual provedor ele fala, e onde vivem a agenda e a ficha. Sem conexão, o assistente responde na Bancada mas não envia para ninguém."
    >
      <FormConexao estado={estado} />
      <FormGoogle integracoes={estado.integracoes} slug={slug} />
    </Ajustes>
  );
}
